import { useMutation } from '@tanstack/react-query';

import type {
  DeletePromotionResponse,
  PromotionFormResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useDeletePromotionMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; id: number }) =>
      HttpClient.request<DeletePromotionResponse>({
        method: 'DELETE',
        url: `${params.url}/${params.id}`,
      }),
  });

export const usePromotionFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: FormData;
    }) =>
      HttpClient.request<PromotionFormResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
  });
